export default "/images/3ef4f613fcf5a111f28600e71a154ea0.png";